import { GatorBackupActionTypes } from './gatorBackup.types';

export const initialState = {
  loading: false,
  buy: {
    invoiceId: null,
  },
  ssoLoading: false,
  ssoLoadingHostingId: null,
  ssoUrl: null,
  ssoError: null,
};

const gatorBackupReducer = (state = initialState, action) => {
  switch (action.type) {
    case GatorBackupActionTypes.GATOR_BACKUP_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case GatorBackupActionTypes.GATOR_BACKUP_BUY_REQUEST: {
      return {
        ...state,
        loading: true,
        buy: {
          ...state.buy,
          invoiceId: null,
        },
      };
    }
    case GatorBackupActionTypes.GATOR_BACKUP_BUY_SUCCESS: {
      return {
        ...state,
        loading: false,
        buy: {
          ...state.buy,
          invoiceId: action.payload && action.payload.invoiceId,
        },
      };
    }
    case GatorBackupActionTypes.GATOR_BACKUP_BUY_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
    case GatorBackupActionTypes.GATOR_BACKUP_BUY_RESET: {
      return {
        ...state,
        loading: false,
        buy: {
          ...state.buy,
          invoiceId: null,
        },
      };
    }
    case GatorBackupActionTypes.SSO_REQUEST:
      return {
        ...state,
        ssoLoading: true,
        ssoLoadingHostingId: action.payload.hostingId,
        ssoUrl: null,
        ssoError: null,
      };
    case GatorBackupActionTypes.SSO_SUCCESS:
      return {
        ...state,
        ssoLoading: false,
        ssoLoadingHostingId: null,
        ssoUrl: action.payload.url,
      };
    case GatorBackupActionTypes.SSO_FAILURE:
      return {
        ...state,
        ssoLoading: false,
        ssoLoadingHostingId: null,
        ssoError: action.payload.error,
      };
    default:
      return state;
  }
};

export default gatorBackupReducer;
